
const header = document.getElementById('header');
const onScroll = () => header && header.classList.toggle('solid', scrollY > 40);
addEventListener('scroll', onScroll, {passive:true}); onScroll();


// Apparition au scroll
// Animation à chaque passage : entre en descendant ET en remontant, se réinitialise en sortant
const io = new IntersectionObserver(es => es.forEach(e => {
  const el = e.target;
  if (e.isIntersecting) { el.classList.remove('above'); el.classList.add('in'); }
  else { el.classList.remove('in'); el.classList.toggle('above', e.boundingClientRect.top < 0); }
}), {threshold:.12, rootMargin:'0px 0px -6% 0px'});
document.querySelectorAll('.rv').forEach(el => io.observe(el));

// Hero liée au scroll : coins qui s'arrondissent, contenu qui monte et se floute, photo en léger parallaxe
(() => { try {
  const hero = document.querySelector('.hero'); if (!hero) return;
  const top = hero.querySelector('.top'), bottom = hero.querySelector('.bottom'), bg = hero.querySelector('.bg');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  let ticking = false;
  const update = () => {
    ticking = false;
    const h = hero.offsetHeight;
    const p = Math.min(Math.max(scrollY / (h * .75), 0), 1);          // 0 en haut, 1 à ~75 % de la hero
    const e = p * p * (3 - 2 * p);                                     // easing doux (smoothstep)
    const maxR = Math.min(Math.max(innerWidth * .06, 32), 120);
    hero.style.setProperty('--r', (e * maxR).toFixed(1) + 'px');
    const content = `translate3d(0,${(-e * 90).toFixed(1)}px,0)`;
    const blur = `blur(${(e * 10).toFixed(2)}px)`;
    const op = (1 - e * .95).toFixed(3);
    for (const el of [top, bottom]) { el.style.transform = content; el.style.filter = blur; el.style.opacity = op; }
    bg.style.transform = `translate3d(0,${(e * 70).toFixed(1)}px,0) scale(${(1 + e * .04).toFixed(3)})`;
  };
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, {passive:true});
  addEventListener('resize', update);
  update();
} catch (e) { console.warn(e); } })();





// Boutons : découpe le texte en lettres pour l'effet de roulement
window.rollify = t => {
  const txt = t.textContent; t.setAttribute('aria-label', txt); t.textContent = ''; t.classList.add('rl');
  [...txt].forEach((c, i) => {
    const ch = document.createElement('span'); ch.className = 'ch'; ch.style.setProperty('--i', i); ch.setAttribute('aria-hidden', 'true');
    const v = c === ' ' ? '\u00a0' : c;
    ch.innerHTML = '<i>' + v + '</i><i>' + v + '</i>';
    t.appendChild(ch);
  });
};
document.querySelectorAll('.btn .t, .fq-cta > span, .atmo-btn .t').forEach(rollify);

// Faites le calcul : compteurs qui se rejouent à chaque passage
(() => { try {
  const fmt = n => n.toLocaleString('fr-FR').replace(/\u202f|\u00a0/g, '\u2009');
  const els = document.querySelectorAll('.calc [data-to]');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const run = el => {
    const to = +el.dataset.to, dur = 1600, t0 = performance.now();
    if (reduce) { el.textContent = fmt(to); return; }
    const step = t => { const p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 4); el.textContent = fmt(Math.round(to * e)); if (p < 1) el._raf = requestAnimationFrame(step); };
    cancelAnimationFrame(el._raf); el._raf = requestAnimationFrame(step);
  };
  const io2 = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) run(e.target); else { cancelAnimationFrame(e.target._raf); e.target.textContent = '0'; } }), {threshold:.4});
  els.forEach(el => io2.observe(el));
} catch (e) { console.warn(e); } })();


// Calculateur "Faites le calcul" : met à jour les chiffres selon les heures choisies
(() => { try {
  const r = document.getElementById('hrs'); if (!r) return;
  const out = document.getElementById('hrsOut'), c5 = r.closest('.c5');
  const fmt = n => n.toLocaleString('fr-FR', {maximumFractionDigits:1}).replace(/\u202f|\u00a0/g, '\u2009');
  const H1 = c5.querySelector('[data-title]'), base = H1.innerHTML;
  const upd = (anim) => {
    const h = +r.value, y = h * 365, t = y * 10, j = Math.round(t / 24);
    out.textContent = fmt(h) + ' h';
    r.style.setProperty('--p', ((h - r.min) / (r.max - r.min) * 100) + '%');
    r.parentNode.style.setProperty('--pn', (h - r.min) / (r.max - r.min));
    c5.querySelectorAll('.c5-chips button').forEach(b => b.setAttribute('aria-pressed', +b.dataset.h === h));
    const sv = c5.querySelector('.sv'); if (sv) sv.textContent = fmt(h) + ' h';
    const set = (k, v) => { const b = c5.querySelector('[data-k="' + k + '"]'); if (!b) return; b.dataset.to = v; b.textContent = fmt(v); if (anim) { b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); } };
    set('d', h); set('y', y); set('t', t); set('j', j);
    const yrs = j / 365;
    const N = v => '<em class="yn">' + v + '</em>';
    const lead = yrs >= 1.9 ? (yrs % 1 >= .85 ? 'Près de ' + N(Math.ceil(yrs)) : 'Plus de ' + N(Math.floor(yrs))) + ' années entières de votre vie.'
      : yrs >= 0.75 ? 'Presque ' + N(1) + ' année entière de votre vie.'
      : yrs >= 0.45 ? 'Plus de ' + N(6) + ' mois de votre vie.'
      : 'Près de ' + N(Math.max(1, Math.round(j / 30))) + ' mois de votre vie.';
    const ld = H1.querySelector('.lead'); if (ld) ld.innerHTML = lead;
  };
  r.addEventListener('input', () => upd(true));
  const go = v => { r.value = Math.min(8, Math.max(1, v)); upd(true); };
  c5.querySelectorAll('.c5-chips button').forEach(b => b.onclick = () => go(+b.dataset.h));
  c5.querySelectorAll('.stp button').forEach(b => b.onclick = () => go(+r.value + +b.dataset.d));
  upd(false);
} catch (e) { console.warn(e); } })();


// Calculateur : démo au premier passage (le curseur glisse seul pour montrer l'interaction)
(() => { try {
  const r = document.getElementById('hrs'); if (!r) return;
  const c5 = r.closest('.c5'); let raf, played = false, stop = false;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const setV = v => { r.value = v; r.dispatchEvent(new Event('input')); };
  const tween = (from, to, dur) => new Promise(res => {
    const t0 = performance.now();
    const step = t => { if (stop) return res(); const p = Math.min((t - t0) / dur, 1), e = p < .5 ? 2*p*p : 1 - Math.pow(-2*p + 2, 2) / 2;
      setV(Math.round((from + (to - from) * e) * 2) / 2); p < 1 ? raf = requestAnimationFrame(step) : res(); };
    raf = requestAnimationFrame(step);
  });
  const wait = ms => new Promise(res => setTimeout(res, ms));
  const demo = async () => {
    c5.classList.add('demo'); await wait(900);
    await tween(5, 2, 1300); await wait(450);
    await tween(2, 5, 1200);
    if (!stop) { setV(5); }
    c5.classList.remove('demo');
  };
  const quit = () => { stop = true; cancelAnimationFrame(raf); c5.classList.remove('demo'); c5.classList.add('tried'); };
  ['pointerdown','keydown','touchstart'].forEach(ev => r.addEventListener(ev, quit, {passive:true}));
  const io3 = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting && !played) { played = true; demo(); } }), {threshold:.55});
  io3.observe(r.closest('.c5-calc'));
} catch (e) { console.warn(e); } })();

// Collection : coloris actif (change le packshot) + favoris
const PK = (window.FM && FM.PK) || {};
Object.values(PK).forEach(v => ['F','C','T'].forEach(t => { const i = new Image(); i.src = v[t]; }));
document.querySelectorAll('.pc').forEach(pc => {
  pc.querySelectorAll('img[data-pk]').forEach(im => { const u = window.FM && FM.cut(im.dataset.pk, FM.def); if (u) im.src = u; });
  pc.querySelectorAll('.sw').forEach(sw => sw.onclick = () => {
    pc.querySelectorAll('.sw').forEach(x => x.classList.toggle('on', x === sw));
    const c = sw.getAttribute('aria-label'), cn = pc.querySelector('.cn'); if (cn) cn.textContent = c;
    const k0 = (pc.querySelector('img[data-pk]') || {}).dataset, vv = k0 && window.FM && FM.V[k0.pk + '|' + c];
    const pu = (k0 && FM.P[k0.pk] && FM.P[k0.pk].url) || FM.url; if (vv && pu) pc.querySelectorAll('a.pc-img, a.pc-btn').forEach(a => a.href = pu + '?variant=' + vv.id);
    pc.querySelectorAll('img[data-pk]').forEach(img => {
      const src = PK[c] && PK[c][img.dataset.pk]; if (!src) return;
      img.style.opacity = 0;
      setTimeout(() => { img.src = src; img.alt = img.alt.replace(/coloris .*$/, 'coloris ' + c); img.style.opacity = 1; window.__pkUpd && window.__pkUpd(); }, 220);
    });
  });
});




// Pack : apparaît en même temps que les cartes produit
(() => { try {
  const pk = document.querySelector('.pk-rv'), pc = document.querySelector('.shop .pc'); if (!pk || !pc) return;
  let seen = false;
  const sync = () => pk.classList.toggle('in', seen || pc.classList.contains('in'));
  new MutationObserver(sync).observe(pc, { attributes: true, attributeFilter: ['class'] });
  new IntersectionObserver(([e]) => { seen = e.isIntersecting; sync(); }, { threshold: 0.08 }).observe(pk);
  sync();
} catch (e) { console.warn(e); } })();
// Dimensions par pièce
document.querySelectorAll('.pk-item').forEach(it => {
  const b = it.querySelector('.pk-dim'), p = it.querySelector('.pk-dimp'); if (!b) return;
  const close = () => { p.hidden = true; b.setAttribute('aria-expanded', 'false'); };
  b.onclick = e => { e.stopPropagation(); const open = p.hidden; document.querySelectorAll('.pk-dimp').forEach(x => x.hidden = true); document.querySelectorAll('.pk-dim').forEach(x => x.setAttribute('aria-expanded','false')); if (open) { p.hidden = false; b.setAttribute('aria-expanded','true'); } };
  p.querySelector('.pk-dx').onclick = close; p.onclick = e => e.stopPropagation();
});
document.addEventListener('click', () => document.querySelectorAll('.pk-dimp').forEach(x => { x.hidden = true; }));
// Composez votre salon : quantités, coloris, total
(() => { try {
  const pk = document.querySelector('.pk'); if (!pk) return;
  const PACK_OFF = FM.OFF, MIN = FM.MIN;
  const fmt = FM.fmt;
  // compteur à rouleaux sur le total
  const roll = (el, v) => {
    const s = fmt(v), prev = el.dataset.s || s, up = v >= (+el.dataset.v || 0);
    el.dataset.s = s; el.dataset.v = v;
    const o = prev.length >= s.length ? prev.slice(prev.length - s.length) : prev.padStart(s.length, ' ');
    const col = '<i>0</i><i>1</i><i>2</i><i>3</i><i>4</i><i>5</i><i>6</i><i>7</i><i>8</i><i>9</i>';
    el.innerHTML = [...s].map((c, i) => /\d/.test(c)
      ? `<span class="od"><span class="od-s" style="transform:translateY(-${(/\d/.test(o[i]) ? +o[i] : 0) * 10}%)">${col}</span></span>`
      : `<span class="od-c">${c}</span>`).join('');
    el.setAttribute('aria-label', s);
    if (prev === s) return;
    const tot = el.closest('.pk-tot'); tot.classList.remove('up', 'down'); void tot.offsetWidth; tot.classList.add(up ? 'up' : 'down');
    requestAnimationFrame(() => requestAnimationFrame(() => {
      const cols = el.querySelectorAll('.od-s'), d = [...s].filter(c => /\d/.test(c));
      cols.forEach((c, k) => { c.style.transitionDelay = (cols.length - 1 - k) * 45 + 'ms'; c.style.transform = `translateY(-${+d[k] * 10}%)`; });
    }));
  };
  // effet : la pièce vole jusqu'à la capsule du pack
  const fly = (it, src) => {
    const img = it.querySelector('.pk-ped img'), cap = pk.querySelector('.pk-cap');
    if (!img || !cap || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const a = img.getBoundingClientRect(), b = cap.getBoundingClientRect();
    const g = img.cloneNode(); g.className = 'pk-fly'; g.removeAttribute('data-pk'); if (src) g.src = src;
    Object.assign(g.style, { left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', height: a.height + 'px' });
    document.body.appendChild(g);
    const tx = b.left + 70 - (a.left + a.width / 2), ty = b.top + b.height / 2 - (a.top + a.height / 2);
    const s = Math.max(.12, 56 / a.width);
    const an = g.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: `translate(${tx * .5}px, ${ty * .5 - 120}px) scale(${(1 + s) / 2})`, opacity: 1, offset: .5 },
      { transform: `translate(${tx}px, ${ty}px) scale(${s})`, opacity: .2 }
    ], { duration: 850, easing: 'cubic-bezier(.45,0,.2,1)' });
    an.onfinish = () => { g.remove(); cap.classList.remove('hit'); void cap.offsetWidth; cap.classList.add('hit'); };
  };
  // panier du pack : une ligne par pièce + couleur (ex. 2 Solo de couleurs différentes)
  const items = [...pk.querySelectorAll('.pk-item')];
  const lines = [];
  const COL = {}; items[0].querySelectorAll('.pk-sw').forEach(b => COL[b.getAttribute('aria-label')] = b.style.getPropertyValue('--c'));
  const srcOf = (i, c) => { const im = items[i].querySelector('img[data-pk]'); return (PK[c] && PK[c][im.dataset.pk]) || im.src; };
  const addLine = (i, c) => { const l = lines.find(l => l.i === i && l.c === c); if (l) l.q++; else lines.push({ i, c, q: 1 }); };
  const decLine = l => { l.q--; if (l.q <= 0) lines.splice(lines.indexOf(l), 1); };
  const upd = () => {
    let n = 0, sum = 0;
    lines.forEach(l => { n += l.q; sum += l.q * FM.price(FM.KS[l.i], l.c); });
    const ok = n >= MIN && PACK_OFF > 0, tot = ok ? FM.pack(sum) : sum;
    pk.querySelector('.pk-n').textContent = n + (n > 1 ? ' pièces' : ' pièce');
    items.forEach((it, i) => {
      const mine = lines.filter(l => l.i === i), box = it.querySelector('.pk-lines');
      it.classList.toggle('off', !mine.length); it.classList.toggle('has', !!mine.length);
      box.innerHTML = mine.length ? '<span class="pk-ln-t">Dans votre pack</span>' : '';
      mine.forEach(l => {
        const r = document.createElement('div'); r.className = 'pk-ln';
        r.innerHTML = `<span class="pk-ln-im"><img src="${srcOf(i, l.c)}" alt=""></span><span class="pk-ln-tx"><b>${it.querySelector('.pk-nm').textContent}</b><em><i style="background:${COL[l.c]}"></i>${l.c}</em></span><div class="pk-q"><button type="button" class="pk-m" aria-label="Retirer un ${l.c}">−</button><output>${l.q}</output><button type="button" class="pk-p" aria-label="Ajouter un ${l.c}">+</button></div>`;
        r.querySelector('.pk-m').onclick = () => { decLine(l); upd(); };
        r.querySelector('.pk-p').onclick = () => { if (l.q >= 6) return; l.q++; fly(it, srcOf(i, l.c)); upd(); };
        box.appendChild(r);
      });
      const nm0 = it.querySelector('.pk-nm').textContent.replace(/^\S+\s/, '');
      it.querySelector('.pk-add').innerHTML = it.dataset.c && mine.length ? `<span aria-hidden="true"><svg viewBox="0 0 10 10" width="9" height="9"><path d="M5 1v8M1 5h8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg></span> ${innerWidth < 768 ? 'Un autre en ' + it.dataset.c : 'Ajouter un autre ' + nm0 + ' en ' + it.dataset.c}` : '<span aria-hidden="true"><svg viewBox="0 0 10 10" width="9" height="9"><path d="M5 1v8M1 5h8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg></span> Ajouter au pack';
      if (mine.length) { const h = document.createElement('p'); h.className = 'pk-hint'; h.innerHTML = `Envie d’un 2<sup>e</sup> ${nm0} dans une autre couleur ? Choisissez-la juste au-dessus, puis <b>« Ajouter un autre »</b>.`; box.appendChild(h); }
    });
    const th = pk.querySelector('.pk-thumbs'); th.innerHTML = '';
    lines.forEach(l => {
      const nm = items[l.i].querySelector('.pk-nm').textContent;
      const d = document.createElement('button'); d.type = 'button'; d.className = 'pk-th1'; d.title = 'Retirer ' + nm + ' ' + l.c; d.setAttribute('aria-label', d.title);
      d.innerHTML = `<img src="${srcOf(l.i, l.c)}" alt="">` + (l.q > 1 ? `<b>×${l.q}</b>` : '') + '<i class="pk-x" aria-hidden="true">×</i>';
      d.onclick = () => { decLine(l); upd(); };
      th.appendChild(d);
    });
    th.classList.toggle('empty', !n);
    const nu = pk.querySelector('.pk-nudge'), pct = Math.round(PACK_OFF * 100);
    nu.className = 'pk-nudge ' + (ok ? 'is-ok' : n ? 'is-one' : 'is-zero');
    nu.innerHTML = ok ? `<span class="pk-ic">✓</span><span>Remise pack appliquée : vous économisez <b>${fmt(sum - tot)}</b></span>`
      : n ? `<span class="pk-ic">+</span><span>Ajoutez une 2<sup>e</sup> pièce et économisez <b>${pct} %</b> sur tout votre salon</span>`
      : `<span class="pk-ic">%</span><span>Composez votre pack : <b>−${pct} %</b> sur l’ensemble dès 2 pièces</span>`;
    pk.querySelector('.pk-old').textContent = ok ? fmt(sum) : '';
    pk.querySelector('.pk-off').textContent = ok ? '−' + pct + ' %' : '';
    pk.querySelector('.pk-eco').textContent = ok ? 'Vous économisez ' + fmt(sum - tot) : '';
    pk.querySelector('.pk-tot').classList.toggle('is-ok', ok);
    roll(pk.querySelector('.pk-new'), tot);
    const cta = pk.querySelector('.pk-cta');
    cta.setAttribute('aria-disabled', n ? 'false' : 'true');
    { const t = cta.querySelector('.t'), v = n ? (n > 1 ? 'Ajouter le pack au panier' : 'Ajouter au panier') : 'Votre pack est vide'; if (t.getAttribute('aria-label') !== v) { t.textContent = v; window.rollify && rollify(t); } }
  };
  items.forEach((it, i) => {
    it.querySelector('.pk-add').onclick = () => {
      if (!it.dataset.c) { it.classList.remove('need'); void it.offsetWidth; it.classList.add('need'); return; }
      addLine(i, it.dataset.c); fly(it, srcOf(i, it.dataset.c)); upd();
    };
    it.querySelectorAll('.pk-sw').forEach(sw => sw.onclick = () => {
      it.querySelectorAll('.pk-sw').forEach(x => x.classList.toggle('on', x === sw));
      const c = sw.getAttribute('aria-label'); it.dataset.c = c; it.querySelector('.pk-lbl .yes b').textContent = c; it.classList.remove('need');
      const img = it.querySelector('img[data-pk]'), src = PK[c] && PK[c][img.dataset.pk]; upd(); if (!src) return;
      img.style.opacity = 0; setTimeout(() => { img.src = src; img.alt = img.alt.replace(/coloris .*$/, 'coloris ' + c); img.style.opacity = 1; }, 220);
    });
  });
  // Couleur présélectionnée par défaut (Crème), modifiable par le client
  const DEF_C = FM.def;
  items.forEach((it, i) => {
    const sw = [...it.querySelectorAll('.pk-sw')].find(x => x.getAttribute('aria-label') === DEF_C); if (!sw) return;
    sw.classList.add('on'); it.dataset.c = DEF_C; it.querySelector('.pk-lbl .yes b').textContent = DEF_C;
    const img = it.querySelector('img[data-pk]'), src = img && PK[DEF_C] && PK[DEF_C][img.dataset.pk];
    if (src) { img.src = src; img.alt = img.alt.replace(/coloris .*$/, 'coloris ' + DEF_C); }
  });
  window.__pk = { lines, upd: () => upd() };
  pk.querySelector('.pk-cta').addEventListener('click', e => { if (e.currentTarget.getAttribute('aria-disabled') === 'true') { e.preventDefault(); items.forEach(it => { if (!it.dataset.c) { it.classList.remove('need'); void it.offsetWidth; it.classList.add('need'); } }); } });
  upd();
} catch (e) { console.warn(e); } })();


// Badge note : s'affiche en étoiles pleines uniquement avec de vrais avis
document.querySelectorAll('.pc-rate').forEach(b => {
  const r = parseFloat(b.dataset.rating), c = parseInt(b.dataset.count || '0', 10);
  if (c > 0 && r > 0) {
    b.querySelector('.st-on').style.setProperty('--r', r);
    
    b.setAttribute('aria-label', 'Note ' + r + ' sur 5, ' + c + ' avis');
  }
});


// Avis : vignettes produit + navigation
(() => { try {
  const sec = document.querySelector('.avis'); if (!sec) return;
  sec.querySelectorAll('img[data-c]').forEach(im => { const d = PK[im.dataset.c]; if (d && d[im.dataset.pk]) im.src = d[im.dataset.pk]; });
} catch (e) { console.warn(e); } })();

// Contenus clients : vignettes produit + flèches
(() => { try {
  const sec = document.querySelector('.ugc'); if (!sec) return;
  sec.querySelectorAll('img[data-c]').forEach(im => { const d = PK[im.dataset.c]; if (d && d[im.dataset.pk]) im.src = d[im.dataset.pk]; });
} catch (e) { console.warn(e); } })();

// Vidéos clients : carrousel manuel infini
(() => { try {
  const sec = document.querySelector('.ugc'); if (!sec) return;
  const tr = sec.querySelector('.ug-track'), belt = sec.querySelector('.ug-belt');
  const third = () => belt.scrollWidth / 3;
  const step = () => { const c = belt.querySelector('.ug-card'); return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(belt).gap || 18) : 320; };
  const wrap = () => { const t = third(); if (tr.scrollLeft < t * .5) tr.scrollLeft += t; else if (tr.scrollLeft > t * 1.5) tr.scrollLeft -= t; };
  const init = () => { tr.scrollLeft = third(); };
  requestAnimationFrame(init); addEventListener('load', init); addEventListener('resize', init);
  let busy = 0;
  tr.addEventListener('scroll', () => { clearTimeout(busy); busy = setTimeout(wrap, 120); }, { passive: true });
  sec.querySelector('.ug-prev').onclick = () => { wrap(); tr.scrollBy({ left: -step(), behavior: 'smooth' }); };
  sec.querySelector('.ug-next').onclick = () => { wrap(); tr.scrollBy({ left: step(), behavior: 'smooth' }); };
  // glisser à la souris
  let down = false, x0 = 0, s0 = 0, moved = false;
  tr.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; down = true; moved = false; x0 = e.clientX; s0 = tr.scrollLeft; });
  addEventListener('pointermove', e => { if (!down) return; const dx = e.clientX - x0; if (Math.abs(dx) > 4) { moved = true; tr.classList.add('drag'); } tr.scrollLeft = s0 - dx; });
  addEventListener('pointerup', () => { if (!down) return; down = false; setTimeout(() => tr.classList.remove('drag'), 0); wrap(); });
  tr.addEventListener('click', e => { if (moved) { e.preventDefault(); moved = false; } }, true);
} catch (e) { console.warn(e); } })();

// Avant-footer : vignette Nuage Solo + choix du coloris (fondu enchaîné + défilement auto)
(() => { try {
  const sec = document.querySelector('.fshow'); if (!sec) return;
  const box = sec.querySelector('.fs-pc'), img = box.querySelector('img');
  const btns = [...sec.querySelectorAll('.fs-sw button')];
  const cols = btns.map(b => b.dataset.c).filter(c => PK[c] && PK[c].F);
  img.src = FM.cut('F', img.dataset.c);
  // calque pour le fondu enchaîné
  const top = img.cloneNode(); top.removeAttribute('data-c'); top.className = 'fs-pc-top'; top.alt = ''; top.setAttribute('aria-hidden', 'true'); box.appendChild(top);
  cols.forEach(c => { const p = new Image(); p.src = PK[c].F; });
  let cur = img.dataset.c, busy = false;
  const mark = c => btns.forEach(x => x.classList.toggle('on', x.dataset.c === c));
  const set = c => {
    const d = PK[c]; if (!d || !d.F || c === cur || busy) return; busy = true; cur = c; mark(c);
    top.src = d.F; top.classList.remove('in'); void top.offsetWidth; top.classList.add('in');
    setTimeout(() => { img.src = d.F; img.alt = FM.P.F.n + ' coloris ' + c; top.classList.remove('in'); busy = false; }, 760);
  };
  // défilement automatique tant que le footer est visible, arrêté dès que le visiteur choisit
  let timer = null, manual = false, hover = false, seen = false;
  const auto = sec.dataset.auto !== 'false' && !matchMedia('(prefers-reduced-motion: reduce)').matches && cols.length > 1;
  const tick = () => { if (manual || hover || !seen) return; set(cols[(cols.indexOf(cur) + 1) % cols.length]); };
  const start = () => { if (auto && !timer && !manual) { const sp = +sec.dataset.speed; timer = setInterval(tick, sp >= 1000 ? sp : 2600); } };
  const stop = () => { clearInterval(timer); timer = null; };
  btns.forEach(b => b.onclick = () => { manual = true; stop(); set(b.dataset.c); });
  box.addEventListener('mouseenter', () => hover = true); box.addEventListener('mouseleave', () => hover = false);
  if (auto && 'IntersectionObserver' in window) new IntersectionObserver(es => es.forEach(e => { seen = e.isIntersecting; seen ? start() : stop(); }), { threshold: .25 }).observe(box);
} catch (e) { console.warn(e); } })();

// Mini boutique flottante : chaque pièce mène à sa carte dans la collection
(() => { try {
  const sk = document.querySelector('.sk'), mini = document.querySelector('.sk-mini'); if (!sk) return;
  const shop = document.querySelector('.shop'), cards = shop ? shop.querySelectorAll('.pc') : [];
  let closed = false;
  const COLS = FM.COLS;
  sk.querySelectorAll('.sk-im').forEach(box => { const base = box.querySelector('img'), k = base.dataset.k; base.remove();
    COLS.forEach(([c], j) => { const im = document.createElement('img'); im.className = 'sk-c' + (j ? '' : ' vis'); im.alt = ''; im.dataset.c = c; if (PK[c] && PK[c][k]) im.src = PK[c][k]; box.appendChild(im); }); });
  const colEl = sk.querySelector('.sk-col') || document.createElement('span'); colEl.innerHTML = colEl.innerHTML || '<em></em>'; let ci = 0, paused = false;
  const show = n => { ci = n; const [c, h] = COLS[n]; colEl.style.setProperty('--sc', h); const em = colEl.querySelector('em'); em.style.opacity = 0; setTimeout(() => { em.textContent = c; em.style.opacity = 1; }, 250);
    sk.querySelectorAll('.sk-im').forEach((box, t) => setTimeout(() => box.querySelectorAll('img').forEach(im => im.classList.toggle('vis', im.dataset.c === c)), t * 140)); };
  setInterval(() => { if (!paused && sk.classList.contains('show') && !document.hidden) show((ci + 1) % COLS.length); }, 1900);
  sk.addEventListener('mouseenter', () => paused = true); sk.addEventListener('mouseleave', () => paused = false);
  const go = (el, card) => {
    const y = el.getBoundingClientRect().top + scrollY - 90;
    window.lenis ? lenis.scrollTo(y) : scrollTo({ top: y, behavior: 'smooth' });
    if (card) { card.classList.remove('sk-hl'); void card.offsetWidth; setTimeout(() => card.classList.add('sk-hl'), 500); }
  };
  sk.querySelectorAll('.sk-p').forEach((p, i) => {
    p.onmouseenter = () => { sk.querySelectorAll('.sk-p').forEach(x => x.classList.toggle('on', x === p)); sk.style.setProperty('--i', i); };
    p.onclick = () => { const c = cards[i]; c ? go(c, c) : shop && go(shop); };
  });
  rollify(sk.querySelector('.sk-go .t'));
  sk.querySelector('.sk-add').onclick = e => { e.preventDefault(); shop && go(shop); };
  sk.querySelector('.sk-x').onclick = () => { closed = true; tick(); };
  mini.onclick = () => { closed = false; tick(); };
  const hero = document.querySelector('.hero'), foot = document.querySelector('.fshow');
  const vis = el => { if (!el) return false; const r = el.getBoundingClientRect(); return r.top < innerHeight * .6 && r.bottom > innerHeight * .4; };
  let ready = false, timer = 0;
  const tick = () => {
    const past = hero ? hero.getBoundingClientRect().bottom < innerHeight * .4 : scrollY > 600;
    const atFoot = foot ? foot.getBoundingClientRect().top < innerHeight * .75 : false;
    // attend 4 s après la sortie de la hero avant la première apparition
    if (past && !ready && !timer) timer = setTimeout(() => { ready = true; tick(); }, 4000);
    if (!past && !ready && timer) { clearTimeout(timer); timer = 0; }
    const on = past && ready && !atFoot && !vis(shop);
    sk.classList.toggle('show', on && !closed); mini.classList.toggle('show', on && closed);
  };
  addEventListener('scroll', tick, { passive: true }); addEventListener('resize', tick); tick();
} catch (e) { console.warn(e); } })();

// Mini boutique : 3 titres selon le moment de la visite
// 1. arrivée (identité) -> 2. lecture, 35 % de la page ou 20 s (projection) -> 3. hésitation, 60 % ou 45 s (permission)
(() => { try {
  const k = document.querySelector('.sk-k'); if (!k) return;
  const T = [
    ['Trois silhouettes, une évidence', 'Quel Nuage vous ressemble ?'],
    ['Fermez les yeux un instant', 'Votre place est déjà prête'],
    ['On vous a vu hésiter', 'Et si c’était le bon ?']
  ];
  const t0 = Date.now(); let cur = 0;
  const set = n => { if (n <= cur) return; cur = n; k.classList.add('swap');
    setTimeout(() => { k.querySelector('small').textContent = T[n][0]; k.querySelector('.sk-tt').textContent = T[n][1]; k.classList.remove('swap'); }, 450); };
  const chk = () => { const r = scrollY / Math.max(1, document.body.scrollHeight - innerHeight), s = (Date.now() - t0) / 1000;
    if (r > .6 || s > 45) set(2); else if (r > .35 || s > 20) set(1); };
  addEventListener('scroll', chk, { passive: true }); setInterval(chk, 1500);
} catch (e) { console.warn(e); } })();

// Menu : vignettes du méga-menu + défilement doux vers les ancres
(() => { try {
  document.querySelectorAll('.mg-im img, .mg-cut img').forEach(im => { const d = PK[FM.def]; if (d && d[im.dataset.k]) im.src = d[im.dataset.k]; });
  const cards = document.querySelectorAll('.shop .pc');
  const go = (el, hl) => { if (!el) return; const y = el.getBoundingClientRect().top + scrollY - 90;
    window.lenis ? lenis.scrollTo(y) : scrollTo({ top: y, behavior: 'smooth' });
    if (hl) { hl.classList.remove('sk-hl'); void hl.offsetWidth; setTimeout(() => hl.classList.add('sk-hl'), 500); } };
  document.querySelectorAll('.nav a[href^="#"], .mg a').forEach(a => a.addEventListener('click', e => {
    const id = a.getAttribute('href').slice(1); if (!id) return; e.preventDefault(); document.activeElement.blur();
    const i = a.dataset.i; i != null && cards[i] ? go(cards[i], cards[i]) : go(document.getElementById(id));
  }));
} catch (e) { console.warn(e); } })();

// Panier latéral : branché sur le panier Shopify (/cart.js, /cart/update.js)
(() => { try {
  const cd = document.querySelector('.cd'), ov = document.querySelector('.cd-ov'); if (!cd || !window.FM) return;
  const P = FM.P, KS = FM.KS, OFF = FM.OFF, MIN = FM.MIN, HEX = FM.HEX, CN = FM.CN;
  const fmt = FM.fmt, img = (k, c) => FM.cut(k, c), pr = (k, c) => FM.price(k, c), pct = Math.round(OFF * 100);
  let ci = 0;
  setInterval(() => { if (!cd.classList.contains('on') || document.hidden) return; ci = (ci + 1) % CN.length;
    cd.querySelectorAll('.cd-bb .cd-d2').forEach((u, t) => { if (!u._list || u._list.length < 2) return; setTimeout(() => { u._i = (u._i + 1) % u._list.length; const c = u._list[u._i]; u.querySelectorAll('img').forEach(im => im.classList.toggle('vis', im.dataset.c === c)); }, t * 140); });
    cd.querySelectorAll('.cd-ui:not(.cd-d2)').forEach((u, t) => setTimeout(() => u.querySelectorAll('img').forEach(im => im.classList.toggle('vis', im.dataset.c === CN[ci])), t * 140)); }, 1900);
  const TAG = {}; KS.forEach(k => TAG[k] = P[k].tag);
  const cart = [];
  const badge = document.querySelector('.bag-n');
  // --- synchronisation Shopify
  let srv = null, pending = false, known = {}, timer = 0, inflight = null;
  const vid = (k, c) => (FM.V[k + '|' + c] || {}).id;
  const apply = j => { srv = j; known = {}; (j.items || []).forEach(it => { if (FM.byId[it.variant_id]) known[it.variant_id] = (known[it.variant_id] || 0) + it.quantity; }); };
  const fromServer = j => { cart.length = 0; (j.items || []).forEach(it => { const m = FM.byId[it.variant_id]; if (!m) return; const l = cart.find(x => x.k === m.k && x.c === m.c); if (l) l.q += it.quantity; else cart.push({ k: m.k, c: m.c, q: it.quantity }); }); apply(j); };
  const load = () => fetch(FM.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json()).then(j => { fromServer(j); pending = false; render(); }).catch(() => {});
  const sync = () => {
    clearTimeout(timer);
    const updates = {}; Object.keys(known).forEach(id => updates[id] = 0);
    cart.forEach(l => { const id = vid(l.k, l.c); if (id) updates[id] = (updates[id] || 0) + l.q; });
    inflight = fetch(FM.root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) })
      .then(r => r.json().then(j => { if (!r.ok) throw j; apply(j); pending = false; render(); }))
      .catch(e => { console.warn(e); cd.classList.add('cd-err'); setTimeout(() => cd.classList.remove('cd-err'), 2500); return load(); })
      .finally(() => { inflight = null; });
    return inflight;
  };
  const commit = () => { pending = true; clearTimeout(timer); timer = setTimeout(sync, 300); render(); };
  const add = (k, c, q = 1) => { const l = cart.find(l => l.k === k && l.c === c); if (l) l.q += q; else cart.push({ k, c, q }); };
  const open = () => { render(); ov.hidden = false; requestAnimationFrame(() => { ov.classList.add('on'); cd.classList.add('on'); }); cd.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('cd-lock'); };
  const close = () => { ov.classList.remove('on'); cd.classList.remove('on'); cd.setAttribute('aria-hidden', 'true'); setTimeout(() => ov.hidden = true, 450); document.documentElement.classList.remove('cd-lock'); };
  const render = () => {
    let n = 0, sum = 0; cart.forEach(l => { n += l.q; sum += l.q * pr(l.k, l.c); });
    const ok = n >= MIN && OFF > 0;
    let tot = ok ? FM.pack(sum) : sum;
    if (srv && !pending) { sum = srv.original_total_price / 100; tot = srv.total_price / 100; }
    const save = Math.max(0, sum - tot);
    cd.classList.toggle('empty', !n);
    cd.querySelector('.cd-n').textContent = n ? '(' + n + ')' : '';
    if (badge) { badge.hidden = !n; if (badge.textContent != n) { badge.textContent = n; badge.classList.remove('pop'); void badge.offsetWidth; badge.classList.add('pop'); } }
    const pack = cd.querySelector('.cd-pack'); pack.classList.toggle('ok', ok); pack.hidden = OFF <= 0;
    cd.querySelector('.cd-pk-tx').innerHTML = ok ? 'Remise pack débloquée : <b>' + fmt(save) + ' économisés</b>' : (MIN - n > 1 ? 'Plus que <b>' + (MIN - n) + ' pièces</b> pour débloquer la remise pack' : 'Plus qu’<b>une pièce</b> pour débloquer la remise pack');
    cd.querySelector('.cd-bar i').style.width = Math.min(100, n / MIN * 100) + '%';
    const ul = cd.querySelector('.cd-lines'); ul.innerHTML = '';
    cart.forEach(l => {
      const li = document.createElement('li'); li.className = 'cd-ln'; const p = P[l.k], full = pr(l.k, l.c) * l.q, net = ok ? FM.pack(full) : full;
      li.innerHTML = `<span class="cd-im"><img src="${img(l.k, l.c)}" alt=""></span>
        <span class="cd-nm"><b>${p.n}</b><span class="cd-cl">${p.t} · <em>${l.c}</em></span><span class="cd-csw" role="group" aria-label="Changer le coloris">${CN.map(c => `<button type="button" data-c="${c}" aria-label="${c}" class="${c === l.c ? 'on' : ''}" style="--c:${HEX[c]}"></button>`).join('')}</span>
        <span class="cd-qr"><span class="cd-q"><button type="button" class="m" aria-label="Retirer un">−</button><output>${l.q}</output><button type="button" class="p" aria-label="Ajouter un">+</button></span></span></span>
        <span class="cd-pr"><span style="display:flex;flex-direction:column-reverse;align-items:flex-end;gap:0">${ok ? `<s>${fmt(full)}</s>` : ''}<b>${fmt(net)}</b></span><button type="button" class="cd-rm">Retirer</button></span>`;
      li.querySelector('.m').onclick = () => { l.q--; if (l.q <= 0) cart.splice(cart.indexOf(l), 1); commit(); };
      li.querySelector('.p').onclick = () => { l.q++; commit(); };
      li.querySelectorAll('.cd-csw button').forEach(b => b.onclick = () => { const c = b.dataset.c; if (c === l.c) return;
        const o = cart.find(x => x !== l && x.k === l.k && x.c === c); if (o) { o.q += l.q; cart.splice(cart.indexOf(l), 1); } else l.c = c; commit(); });
      if (window.__cdNew && window.__cdNew.k === l.k && window.__cdNew.c === l.c) { li.classList.add('cd-fresh'); window.__cdNew = null; }
      li.querySelector('.cd-rm').onclick = () => { cart.splice(cart.indexOf(l), 1); commit(); };
      ul.appendChild(li);
    });
    const up = cd.querySelector('.cd-up-l'); up.innerHTML = '';
    const have = new Set(cart.map(l => l.k)), dl = n ? cart[cart.length - 1] : null, sug = KS;
    const duo = cd.querySelector('.cd-duo'); duo.innerHTML = ''; duo.hidden = !dl;
    if (dl) {
      const title = ok ? 'Complétez <em>votre salon</em>' : 'Ajoutez une 2<sup>e</sup> pièce';
      const sub = ok ? 'La remise pack s’applique déjà à chaque pièce ajoutée.' : (OFF > 0 ? '<strong>−' + pct + ' % sur tout</strong> le panier dès ' + MIN + ' pièces' : '');
      duo.innerHTML = `<div class="cd-dv-in cd-bb"><div class="cd-bb-h"><b>${title}</b><span>${sub}</span></div><div class="cd-bb-l">${KS.map(k => {
          const used = cart.filter(x => x.k === k).map(x => x.c), free = CN.filter(c => !used.includes(c)), c0 = free[0] || CN[0];
          const base = pr(k, c0), net = OFF > 0 && (ok || n + 1 >= MIN) ? FM.pack(base) : base;
          return `<button type="button" class="cd-bb-p" data-k="${k}"><span class="cd-ui cd-d2">${(free.length ? free : CN).map((c, i) => `<img data-c="${c}" class="${i === 0 ? 'vis' : ''}" src="${img(k, c)}" alt="">`).join('')}</span>
            <b>${P[k].v}</b><em>${net !== base ? `<s>${fmt(base)}</s>` : ''}${fmt(net)}</em><i><svg viewBox="0 0 12 12"><path d="M6 1.5v9M1.5 6h9"/></svg></i></button>`; }).join('')}</div></div>`;
      duo.querySelectorAll('.cd-bb-p').forEach(b => {
        const u = b.querySelector('.cd-d2'); u._list = [...u.querySelectorAll('img')].map(i => i.dataset.c); u._i = 0;
        b.onclick = () => { const k = b.dataset.k, c = u._list[u._i] || CN[0]; add(k, c, 1); window.__cdNew = { k, c }; commit(); };
      });
    }
    cd.querySelector('.cd-up').style.display = sug.length ? '' : 'none';
    cd.querySelector('.cd-up-t').innerHTML = n ? 'Complétez <em>votre salon</em>' : 'Nos <em>trois pièces</em>';
    sug.forEach(k => { const b = document.createElement('button'); b.type = 'button'; b.className = 'cd-u';
      b.innerHTML = `<i><svg viewBox="0 0 12 12" width="12" height="12"><path d="M6 1.5v9M1.5 6h9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" fill="none"/></svg></i><span class="cd-ui">${CN.map((c, j) => `<img data-c="${c}" class="${j === ci ? 'vis' : ''}" src="${img(k, c)}" alt="">`).join('')}</span><small class="cd-ut">${TAG[k] || ''}</small><b>${P[k].n}${have.has(k) ? `<small class="cd-u2">Un 2<sup>e</sup> coloris ?${n < MIN && OFF > 0 ? ' · <strong>−' + pct + ' %</strong>' : ''}</small>` : ''}</b><em>${fmt(pr(k, CN[ci]))}</em>`;
      b.onclick = () => { const used = cart.filter(x => x.k === k).map(x => x.c); let c = CN[ci]; if (used.includes(c)) c = CN.find(x => !used.includes(x)) || c; add(k, c, 1); window.__cdNew = { k, c }; commit(); }; up.appendChild(b); });
    cd.querySelector('.cd-sub').textContent = fmt(sum);
    const dr = cd.querySelector('.cd-disc'); dr.hidden = !(save > 0.004); cd.querySelector('.cd-dv').textContent = '−' + fmt(save);
    cd.querySelector('.cd-total').textContent = fmt(tot);
    const x3 = cd.querySelector('.cd-3x'); x3.hidden = !FM.x3; x3.textContent = 'ou 3 × ' + fmt(Math.ceil(tot / 3 * 100) / 100) + ' sans frais';
    cd.classList.toggle('cd-busy', pending);
  };
  window.rollify && rollify(cd.querySelector('.cd-go .t'));
  const bag = document.querySelector('.bag'); bag && bag.addEventListener('click', e => { e.preventDefault(); open(); });
  ov.onclick = close; cd.querySelector('.cd-x').onclick = close;
  addEventListener('keydown', e => { if (e.key === 'Escape' && cd.classList.contains('on')) close(); });
  cd.querySelector('.cd-go').addEventListener('click', e => { e.preventDefault(); const go = () => { location.href = FM.root + 'checkout'; };
    if (!cart.length) return; if (pending || inflight) { (inflight || sync()).then(go, go); } else go(); });
  // ajout depuis « Composez votre salon »
  document.querySelectorAll('.pk-cta').forEach(cta => cta.addEventListener('click', e => { if (cta.getAttribute('aria-disabled') === 'true' || !window.__pk) return; e.preventDefault();
    window.__pk.lines.forEach(l => add(KS[l.i], l.c, l.q)); const last = window.__pk.lines[window.__pk.lines.length - 1]; if (last) window.__cdNew = { k: KS[last.i], c: last.c };
    window.__pk.lines.length = 0; window.__pk.upd(); commit(); open(); }));
  window.__cdAddOpen = (k, c, q = 1) => { add(k, c, q); window.__cdNew = { k, c }; commit(); open(); };
  window.__cdOpen = open;
  render(); load();
  addEventListener('pageshow', e => { if (e.persisted) load(); });
} catch (e) { console.warn(e); } })();


// Panier : dates de livraison estimées
(() => { const d = new Date(), f = (x, o) => x.toLocaleDateString('fr-FR', o);
  const a = new Date(d.getTime() + FM.ETA[0] * 864e5), b = new Date(d.getTime() + FM.ETA[1] * 864e5);
  const e = document.querySelector('.cd-eta'); if (e) e.textContent = 'entre le ' + f(a, { day: 'numeric', month: 'short' }) + ' et le ' + f(b, { day: 'numeric', month: 'short' });
  const z = document.querySelector('.cd-d0'); if (z) z.textContent = 'aujourd’hui'; })();

// Pack : points du carrousel mobile
(() => { const r = document.querySelector('.pk-items'), d = document.querySelectorAll('.pk-dots i'); if (!r || !d.length) return;
  const its = r.querySelectorAll('.pk-item');
  const upd = () => { const c = r.scrollLeft + r.clientWidth / 2; let b = 0, bd = 1e9; its.forEach((it, i) => { const m = it.offsetLeft + it.offsetWidth / 2, dd = Math.abs(m - c); if (dd < bd) { bd = dd; b = i; } }); d.forEach((x, i) => x.classList.toggle('on', i === b)); cur = b; if (pv) { pv.disabled = b === 0; nx.disabled = b === its.length - 1; } };
  let cur = 0; const pv = document.querySelector('.pk-prev'), nx = document.querySelector('.pk-next');
  const go = i => { i = Math.max(0, Math.min(its.length - 1, i)); r.scrollTo({ left: its[i].offsetLeft - (r.clientWidth - its[i].offsetWidth) / 2, behavior: 'smooth' }); };
  pv && (pv.onclick = () => go(cur - 1)); nx && (nx.onclick = () => go(cur + 1));
  d.forEach((x, i) => x.onclick = () => go(i));
  const start = () => { if (innerWidth >= 768 || r.scrollWidth <= r.clientWidth) return; const it = its[1]; r.scrollLeft = it.offsetLeft - (r.clientWidth - it.offsetWidth) / 2; upd(); };
  start(); addEventListener('load', start);
  r.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); })();

// Atmosphère : place les points sur la photo (suit le recadrage object-fit)
(() => { const card = document.querySelector('.c-atmo'); if (!card) return; const im = card.querySelector(':scope > img'), box = card.querySelector('.atmo-hs'); if (!im || !box) return;
  const place = () => { const W = im.naturalWidth, H = im.naturalHeight; if (!W) return;
    const cw = im.offsetWidth, ch = im.offsetHeight, sc = Math.max(cw / W, ch / H), rw = W * sc, rh = H * sc;
    const op = getComputedStyle(im).objectPosition.split(' ').map(v => parseFloat(v) / 100);
    const ox = (cw - rw) * (isNaN(op[0]) ? .5 : op[0]), oy = (ch - rh) * (isNaN(op[1]) ? .5 : op[1]);
    box.style.left = im.offsetLeft + 'px'; box.style.top = im.offsetTop + 'px'; box.style.width = cw + 'px'; box.style.height = ch + 'px'; box.style.right = 'auto'; box.style.bottom = 'auto';
    box.querySelectorAll('.cu-hs').forEach(h => { const x = ox + rw * h.dataset.x / 100, y = oy + rh * h.dataset.y / 100; h.style.left = x + 'px'; h.style.top = y + 'px'; h.style.display = (x < 20 || x > cw - 20 || y < 20 || y > ch - 20) ? 'none' : ''; }); };
  im.complete ? place() : im.addEventListener('load', place); addEventListener('resize', place); addEventListener('load', place); })();

// Menu mobile
(() => { const mm = document.querySelector('.mm'), bg = document.querySelector('.burger'); if (!mm || !bg) return;
  const CN = FM.CN;
  mm.querySelectorAll('.mm-p span').forEach(sp => CN.forEach((c, j) => { const im = document.createElement('img'); im.alt = ''; im.dataset.c = c; im.src = (PK[c] && PK[c][sp.dataset.k]) || ''; if (!j) im.className = 'vis'; sp.appendChild(im); }));
  let ci = 0; setInterval(() => { if (!mm.classList.contains('on')) return; ci = (ci + 1) % CN.length; mm.querySelectorAll('.mm-p span').forEach((sp, t) => setTimeout(() => sp.querySelectorAll('img').forEach(im => im.classList.toggle('vis', im.dataset.c === CN[ci])), t * 140)); }, 1900);
  const open = () => { mm.classList.add('on'); mm.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('cd-lock'); window.lenis && lenis.stop && lenis.stop(); };
  const close = () => { mm.classList.remove('on'); mm.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('cd-lock'); window.lenis && lenis.start && lenis.start(); };
  bg.addEventListener('click', e => { e.preventDefault(); open(); });
  mm.querySelector('.mm-x').onclick = close;
  addEventListener('keydown', e => { if (e.key === 'Escape' && mm.classList.contains('on')) close(); });
  const cards = document.querySelectorAll('.shop .pc');
  mm.querySelectorAll('a[href^="#"]').forEach(a => a.addEventListener('click', e => { const id = a.getAttribute('href').slice(1); const el = document.getElementById(id); if (!el) return; e.preventDefault(); close();
    const tg = a.dataset.i != null && cards[a.dataset.i] ? cards[a.dataset.i] : el;
    setTimeout(() => { const y = tg.getBoundingClientRect().top + scrollY - 80; window.lenis ? lenis.scrollTo(y) : scrollTo({ top: y, behavior: 'smooth' });
      if (tg !== el) { tg.classList.remove('sk-hl'); void tg.offsetWidth; setTimeout(() => tg.classList.add('sk-hl'), 500); } }, 350); }));
  window.rollify && rollify(mm.querySelector('.mm-cta .t'));
})();

// Boutons « Découvrir le Nuage » : descente douce vers la collection
document.querySelectorAll('.hero .btn[href="#collection"], .vc-b .cta-b[href="#collection"]').forEach(a => a.addEventListener('click', e => {
  const el = document.getElementById('collection'); if (!el) return; e.preventDefault();
  const y = el.getBoundingClientRect().top + scrollY - (innerWidth < 768 ? 60 : 80);
  window.lenis ? lenis.scrollTo(y) : scrollTo({ top: y, behavior: 'smooth' }); }));

/* Mobile : titre de la 2e section visible dès l'arrivée, sous la hero */
if (matchMedia('(max-width:767px)').matches) setTimeout(() => document.querySelectorAll('.vs-head .rv').forEach(el => el.classList.add('in')), 900);

// Pastilles de couleur (avis, etc.) : couleur reprise des réglages du thème
document.querySelectorAll('[data-hexc]').forEach(el => { const h = window.FM && FM.HEX[el.dataset.hexc]; if (h) el.style.background = h; });

// Vidéos clients : lecture dans une fenêtre
(() => { try {
  const links = document.querySelectorAll('.js-vid'); if (!links.length) return;
  const lb = document.createElement('div'); lb.className = 'fm-vlb'; lb.hidden = true;
  lb.innerHTML = '<div class="fm-vlb-in"><video playsinline controls></video><p class="fm-vlb-c"></p><button type="button" class="fm-vlb-x" aria-label="Fermer"><svg viewBox="0 0 24 24"><path d="M5 5l14 14M19 5L5 19"/></svg></button></div>';
  document.body.appendChild(lb); const v = lb.querySelector('video');
  const close = () => { v.pause(); lb.classList.remove('on'); setTimeout(() => { lb.hidden = true; v.removeAttribute('src'); v.load(); }, 300); document.documentElement.classList.remove('cd-lock'); };
  links.forEach(a => a.addEventListener('click', e => { if (a.closest('.ug-track.drag')) return; e.preventDefault(); v.src = a.getAttribute('href'); lb.querySelector('.fm-vlb-c').textContent = a.dataset.cap || '';
    lb.hidden = false; requestAnimationFrame(() => lb.classList.add('on')); document.documentElement.classList.add('cd-lock'); v.play().catch(() => {}); }));
  lb.addEventListener('click', e => { if (e.target === lb || e.target.closest('.fm-vlb-x')) close(); });
  addEventListener('keydown', e => { if (e.key === 'Escape' && !lb.hidden) close(); });
} catch (e) { console.warn(e); } })();


// Chat Shopify Inbox (web component shopify-chat) : liens [data-open-chat]
(() => { try {
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-open-chat]'); if (!a) return;
    const sc = document.querySelector('shopify-chat');
    const b = sc && sc.shadowRoot && sc.shadowRoot.querySelector('button[part~="activator"], button.activator');
    if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation();
    const mm = document.querySelector('.mm.on'); if (mm) { const x = mm.querySelector('.mm-x'); x && x.click(); }
    if (b.getAttribute('aria-expanded') !== 'true') b.click();
  }, true);
} catch (e) { console.warn(e); } })();

// Inspirations : défilement automatique doux (pause au survol, au toucher, aux flèches, hors écran)
(() => { try {
  const sec = document.querySelector('.ugc'); if (!sec) return;
  const tr = sec.querySelector('.ug-track'), belt = sec.querySelector('.ug-belt'); if (!tr || !belt) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const SPEED = 0.35; // px par image (~21 px/s)
  let pos = null, hold = 0, hover = false, down = false, visible = false, last = 0;
  const third = () => belt.scrollWidth / 3;
  const pause = ms => { hold = Math.max(hold, performance.now() + ms); pos = null; };
  tr.addEventListener('mouseenter', () => { hover = true; });
  tr.addEventListener('mouseleave', () => { hover = false; pause(600); });
  tr.addEventListener('pointerdown', () => { down = true; });
  addEventListener('pointerup', () => { if (down) { down = false; pause(2500); } });
  tr.addEventListener('touchstart', () => pause(4000), { passive: true });
  tr.addEventListener('wheel', () => pause(2500), { passive: true });
  sec.querySelectorAll('.ug-prev,.ug-next').forEach(b => b.addEventListener('click', () => pause(4000)));
  sec.addEventListener('focusin', () => pause(6000));
  new IntersectionObserver(es => { visible = es[0].isIntersecting; pos = null; }, { threshold: 0.15 }).observe(tr);
  const tick = t => {
    const dt = last ? Math.min(t - last, 50) : 16; last = t;
    if (visible && !hover && !down && t > hold && !document.hidden) {
      if (pos === null) pos = tr.scrollLeft;
      pos += SPEED * dt / 16.67;
      const T = third(); if (T > 0 && pos > T * 1.5) pos -= T;
      tr.scrollLeft = pos;
    }
    requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
} catch (e) { console.warn(e); } })();
